import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { Metric } from '../../interfaces/metric.interface';
import { AutocompleteResult } from 'SearchApp/ts/interfaces/autocomplete-result.interface';

import { SingleMetricByCategoryListComponent } from 'CalculationsApp/ts/features/metric-selector-modal/components/single-metric-by-category-list/single-metric-by-category-list.component';
import { MetricSelectorModalDirective } from '../metric-selector-modal/metric-selector-modal.directive';

/**
 * Single Select Metric Modal
 *
 * A modal that allows users to select at most one metric.
 * This modal is opened by metric-autocomplete-in-place 'handleButtonClick'
 *
 * Inputs:
 *    selectedMetricName: The internal name of the metric to be preselected on modal open
 *
 * Outputs:
 *    selectMetricHandler: An event emitter that emits the selected metric.
 */
@Component({
    standalone: false,
    selector: 'ycn-single-metric-selector-modal',
    templateUrl: './single-metric-selector-modal.template.html',
})
export class SingleMetricSelectorModalComponent extends MetricSelectorModalDirective {
    @ViewChild(SingleMetricByCategoryListComponent) singleMetricByCategoryList!: SingleMetricByCategoryListComponent;

    @Input() selectedMetricName?: string;

    @Output() submitModalHandler: EventEmitter<Metric> = new EventEmitter<Metric>();

    @Output() submitModalAutocompleteHandler: EventEmitter<AutocompleteResult> = new EventEmitter<AutocompleteResult>();

    submitModal(metric: Metric): void {
        const validMetrics = this.featureService.validateFeatureNeeded([metric], this.featureNeededModal);
        if (validMetrics.length > 0) {
            this.submitModalHandler.emit(metric);
        }

        // Because only one metric is selected, automatically close the modal
        this.closeModal();
    }

    submitModalAutocomplete(autocompleteResult: AutocompleteResult): void {
        const validResults = this.featureService.validateFeatureNeeded([autocompleteResult], this.featureNeededModal);
        if (validResults.length > 0) {
            this.submitModalAutocompleteHandler.emit(autocompleteResult);
        }
        // Because only one metric is selected, automatically close the modal
        this.closeModal();
    }

    resetModal(): void {
        this.singleMetricByCategoryList.reset();
    }
}
